import { PageOrientation, convertMillimetersToTwip } from "docx";

export const useWordPageSize = () => {
  return {
    size: {
      orientation: PageOrientation.PORTRAIT,
      height: convertMillimetersToTwip(279),
      width: convertMillimetersToTwip(216),
    },
  };
};
